"use client";

import Link from "next/link";
import MobileMenu from "./mobile-menu";
import NavDropdown from "@/components/nav/dropdown";
import { DropdownItem } from "@/components/nav/dropdown/dropdown-item";
import HeaderShell from "@/components/header/header-shell";
import HeaderBrand from "@/components/header/header-brand";
import HeaderAuthSection from "@/components/header/header-auth-section";
import { useHeaderAuth } from "@/components/header/use-header-auth";
import { getAgencyDisplayName } from "@/components/header/utils";
import { Button } from "@/components/button";

interface Props {
  profile: any;
}

export default function WebsiteHeader({ profile }: Readonly<Props>) {
  const auth = useHeaderAuth("/website/landing");
  const agencyName = getAgencyDisplayName(profile);

  return (
    <HeaderShell>
      <section className="flex items-center">
        <div className="md:hidden">
          <MobileMenu isLoggedIn={auth.isLoggedIn} />
        </div>

        <HeaderBrand
          href="/website/landing"
          name={agencyName}
        />

        <nav className="hidden md:flex items-center gap-4 lg:gap-8 text-ordinary text-sm lg:text-base font-bold mr-10">

          <Link href="/website/facilities">امکانات</Link>

          <Link href="/website/about-us">داستان مشاور</Link>

          <NavDropdown label="آگهی‌ها و مشاوران">

            <DropdownItem href="/advertisements-consultants/advertisements-filter">
              آگهی‌ها
            </DropdownItem>

            <DropdownItem href="/advertisements-consultants/agencies">
              بنگاه ها
            </DropdownItem>

          </NavDropdown>

          {/* temp */}
          {/* <NavDropdown label="آموزش‌ها">

            <DropdownItem href="/video-tutorials">‌آموزش‌های ویدئویی</DropdownItem>

            <DropdownItem href="/articles">مقالات</DropdownItem>

          </NavDropdown> */}

          <Link href="/website/contact-us">ارتباط با ما</Link>

          <Link href="/create-ads">ثبت آگهی</Link>

        </nav>
      </section>

      <HeaderAuthSection
        auth={auth}
        loggedOutContent={
          <>
            <Link
              href="/login-otp"
              className="hidden md:inline font-normal text-brand-700 text-sm md:text-base"
            >
              وارد شوید
            </Link>
            <Button
              variant="bare"
              type="button"
              text="15 روز اشتراک رایگان"
              className="w-36 md:w-44 h-10 md:h-12 bg-primary text-sm md:text-lg hover:bg-blue-700 text-white font-medium rounded-[50px] transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
            />
          </>
        }
      />
    </HeaderShell>
  );
}
